import PlayArrow from '@mui/icons-material/PlayArrow';
import { Box, CardActionArea, Grid } from '@mui/material';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { NormalButton } from 'components/atoms/Button';
import {
  CustomAvatarGroup,
  CustomCardContent,
  AvatarGroupText,
  StackedAvatar,
  ParaText,
  TitleText,
} from './Styles';
import SuperScriptStr from 'components/atoms/String/SuperScriptStr';
import * as React from 'react';
import ShareNftModal from 'components/molecules/ShareNftModal';
import { useNavigate } from 'react-router-dom';

interface NftCardProps {
  ownerName: string;
  splitWith: string;
  name: string;
  price: string;
  currency: string;
  views: number;
  image: string;
  id?: number;
  userAvatar?: string;
  poster: string;
}

const NftCard: React.FC<NftCardProps> = ({
  ownerName,
  splitWith,
  name,
  price,
  currency,
  views,
  image,
  id,
  userAvatar,
}) => {
  const userImg = require('assets/Profile/buku_default_avatar.png');
  const navigate = useNavigate();

  const videoRef = React.useRef<any>();

  const startPreview = () => {
    if (videoRef.current) {
      videoRef.current.muted = true;
      videoRef.current.currentTime = 1;
      videoRef.current.playbackRate = 0.5;
      videoRef.current.play();
    }
  };

  const stopPreview = () => {
    videoRef.current.currentTime = 0;
    videoRef.current.playbackRate = 1;
    videoRef.current.pause();
  };

  return (
    <div style={{ position: 'relative' }}>
      <Card
        onMouseOver={startPreview}
        onMouseLeave={stopPreview}
        sx={{
          borderRadius: '25px',
          background: '#313646',
          maxHeight: { xs: '420px', lg: '500px' },
          position: 'relative',
          overflowX: 'hidden',
          maxWidth: { xs: '250px', lg: '450px' },
        }}
      >
        <CardActionArea style={{ position: 'static' }}>
          <CardMedia
            onClick={() => navigate(`/explore/${id}`)}
            component={'video'}
            src={image + '#t=0,2'}
            loop
            ref={videoRef}
            muted
            style={{ height: '500px', width: '330px' }}
            sx={{
              borderRadius: '25px',
              objectFit: 'cover',
            }}
          />
          <CustomAvatarGroup max={4}>
            <AvatarGroupText
              sx={{
                paddingRight: '12px',
                opacity: '.64',
              }}
              className="avatar-group-text"
            >
              Owned By
            </AvatarGroupText>
            <StackedAvatar alt={ownerName} src={userAvatar || userImg} />
            <AvatarGroupText
              sx={{ paddingLeft: '5px !important' }}
              className="avatar-group-text"
            >
              @{ownerName}
            </AvatarGroupText>
          </CustomAvatarGroup>
          <CustomAvatarGroup max={6} style={{ top: '20%' }}>
            <AvatarGroupText
              sx={{
                opacity: '.64',
              }}
              className="avatar-group-text"
            >
              Split with
            </AvatarGroupText>
            <StackedAvatar
              className="hover-show"
              alt={splitWith}
              src={userImg}
            />

            <AvatarGroupText className="avatar-group-text">
              @{splitWith}
            </AvatarGroupText>
          </CustomAvatarGroup>
          <CustomCardContent>
            <TitleText>{name}</TitleText>
            <Grid container style={{ marginTop: '1rem' }}>
              <Grid item xs={6} style={{ textAlign: 'left', zIndex: 10 }}>
                <ParaText
                  style={{
                    fontSize: '1rem',
                    margin: '0px',
                    color: '#C1C1C1',
                  }}
                >
                  {'RESERVE PRICE'}
                </ParaText>
                <SuperScriptStr
                  text={price || '0.11'}
                  sup={currency || 'ETH'}
                  style={{
                    color: '#e5e5e5',
                    fontSize: '1.1rem',
                    display: 'flex',
                    alignItems: 'center',
                    fontWeight: 600,
                  }}
                />
              </Grid>
              <Grid item xs={6} style={{ textAlign: 'right', zIndex: 10 }}>
                <NormalButton color="transparent">
                  <PlayArrow
                    style={{
                      opacity: '0.9',
                      color: '#ffffff',
                      padding: 'unset',
                      fontSize: '1.1rem',
                      marginRight: '5px',
                    }}
                  />
                  <ParaText style={{ margin: '0px' }}>{views}</ParaText>
                </NormalButton>
              </Grid>
              <ShareNftModal
                ownerName={ownerName}
                name={name}
                splitWith={splitWith}
                price={price}
                currency={currency}
                views={views}
                poster={''}
                image={''}
              />
            </Grid>
          </CustomCardContent>
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              width: '100%',
              height: '90px',
              background:
                'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(0,0,0,0.7) 80%);',
            }}
          ></Box>
        </CardActionArea>
      </Card>
    </div>
  );
};

export default NftCard;
